<template>
  <div id="clients-list">
    <table class="table" v-if="$store.state.responsive.viewDesktopLists">
      <thead class="fixheader">
        <tr>
          <th
            scope="col"
            class="align-middle"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            <ThOrder
              :textHeader="'DNI'"
              :idHeader="'documentNumber'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th
            scope="col"
            class="align-middle"
            v-if="$store.state.roles.Backoffice_member_empresas"
          >
            <ThOrder
              :textHeader="'CIF'"
              :idHeader="'documentNumber'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th
            scope="col"
            class="align-middle"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            <ThOrder
              :textHeader="'Nombre'"
              :idHeader="'name'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th
            scope="col"
            class="align-middle"
            v-if="$store.state.roles.Backoffice_member_empresas"
          >
            <ThOrder
              :textHeader="'Nombre compañía'"
              :idHeader="'name'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th
            scope="col"
            class="align-middle"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            <ThOrder
              :textHeader="'Apellidos'"
              :idHeader="'surnames'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th
            scope="col"
            class="align-middle"
            style="min-width: 12ch !important; word-break: break-all"
          >
            <ThOrder
              :textHeader="'Email'"
              :idHeader="'email'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th
            scope="col"
            class="align-middle"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            <ThOrder
              :textHeader="'Fijo'"
              :idHeader="'fixPhone'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th scope="col" class="align-middle" @click="selectOrder('phone')">
            <ThOrder
              :textHeader="'Móvil'"
              :idHeader="'phone'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th
            scope="col"
            class="align-middle"
            @click="selectOrder('createdDate')"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            <ThOrder
              :textHeader="'Fecha contrato'"
              :idHeader="'createdDate'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th
            scope="col"
            class="align-middle"
            @click="selectOrder('createdDate')"
            v-if="$store.state.roles.Backoffice_member_empresas"
          >
            <ThOrder
              :textHeader="'Fecha'"
              :idHeader="'createdDate'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th scope="col" class="align-middle" @click="selectOrder('city')">
            <ThOrder
              :textHeader="'Localidad'"
              :idHeader="'city'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th
            scope="col"
            class="align-middle"
            @click="selectOrder('postalCode')"
          >
            <ThOrder
              :textHeader="'CP'"
              :idHeader="'postalCode'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <!-- Nuevas columnas para la gestión de la White List y categorías de crédito -->
          <!-- Columna para categoría de crédito asignada, solo visible para usuarios con permisos -->
          <th scope="col" class="align-middle" v-if="canManageWhiteList">
            <ThOrder
              :textHeader="'Categoría de Crédito'"
              :idHeader="'creditCategory'"
              :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"
            ></ThOrder>
          </th>
          <th scope="col" class="align-middle thOperaciones"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(client, index) in clientsAux" v-bind:key="client.clientId">
          <td class="align-middle py-4">{{ client.legalIdentifier }}</td>
          <td class="align-middle py-4">{{ client.name }}</td>
          <td
            class="align-middle py-4"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            {{ client.surnames }}
          </td>
          <td
            class="align-middle py-4"
            style="min-width: 12ch !important; word-break: break-all"
          >
            {{ client.email }}
          </td>
          <td
            class="align-middle py-4"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            {{ client.telephone || "-" }}
          </td>
          <td class="align-middle py-4">{{ client.mobile }}</td>
          <td class="align-middle py-4">
            {{ $dateBackToFront(client.createdDate) }}
          </td>
          <td class="align-middle py-4">
            {{ client.deliveryAddress ? client.deliveryAddress.city : "-" }}
          </td>
          <td class="align-middle py-4">
            {{
              client.deliveryAddress ? client.deliveryAddress.postalCode : "-"
            }}
          </td>
          <td id="operaciones" class="align-middle py-4 tdOperaciones">
            <div class="dropdown dropdown-inherit">
              <span
                id="dropdownOperations"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <v-icon name="fa-ellipsis-v" />
              </span>
              <div
                class="dropdown-menu p-0 dropdown-menu-right"
                aria-labelledby="dropdownOperations"
              >
                <a
                  class="dropdown-item py-3 px-4"
                  href="#"
                  @click="detalleClient(client.legalIdentifier)"
                  >Ver cliente</a
                >
                <a
                  class="dropdown-item py-3 px-4"
                  href="#"
                  @click="
                    editarDetalle(
                      index,
                      client.legalIdentifier,
                      'contractsDetail'
                    )
                  "
                  >Ver contratos</a
                >
                <a
                  class="dropdown-item py-3 px-4"
                  href="#"
                  @click="
                    editarDetalle(index, client.legalIdentifier, 'clientEdit')
                  "
                  >Editar datos del cliente</a
                >
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="!$store.state.responsive.viewDesktopLists">
      <div
        class="card p-2 mb-3"
        v-for="(client, index) in clientsAux"
        v-bind:key="client.clientId"
      >
        <div class="list-item">
          <div
            class="item d-flex align-items-center justify-content-between px-2 py-3"
            data-toggle="collapse"
            :href="'#collapseExample' + index"
            role="button"
            aria-expanded="true"
            :aria-controls="'collapseExample' + index"
          >
            <h4 class="m-0">
              {{ client.legalIdentifier }} - {{ client.name }}
            </h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div
            class="collapse show ml-3 mr-2 borderFirstItem"
            :id="'collapseExample' + index"
          >
            <div
              class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2"
            >
              <div class="d-flex align-items-center justify-content-start">
                <p
                  v-if="!$store.state.roles.Backoffice_member_empresas"
                  class="m-0 mr-2"
                >
                  <strong>DNI: </strong>{{ client.legalIdentifier }}
                </p>
                <p
                  v-if="$store.state.roles.Backoffice_member_empresas"
                  class="m-0 mr-2"
                >
                  <strong>CIF: </strong>{{ client.legalIdentifier }}
                </p>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span
                    id="dropdownOperations"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div
                    class="dropdown-menu p-0 dropdown-menu-right"
                    aria-labelledby="dropdownOperations"
                  >
                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="detalleClient(client.legalIdentifier)"
                      >Ver cliente</a
                    >
                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        editarDetalle(
                          index,
                          client.legalIdentifier,
                          'contractsDetail'
                        )
                      "
                      >Ver contratos</a
                    >
                    <a
                      class="dropdown-item py-3 px-4"
                      href="#"
                      @click="
                        editarDetalle(
                          index,
                          client.legalIdentifier,
                          'clientEdit'
                        )
                      "
                      >Editar datos del cliente</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p
                v-if="!$store.state.roles.Backoffice_member_empresas"
                class="m-0 mr-2"
              >
                <strong>Nombre: </strong>{{ client.name }}
              </p>
              <p
                v-if="$store.state.roles.Backoffice_member_empresas"
                class="m-0 mr-2"
              >
                <strong>Nombre compañía: </strong>{{ client.name }}
              </p>
            </div>
            <div
              v-if="!$store.state.roles.Backoffice_member_empresas"
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Apellidos: </strong>{{ client.surnames }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2"><strong>Email: </strong>{{ client.email }}</p>
            </div>
            <div
              v-if="!$store.state.roles.Backoffice_member_empresas"
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Fijo: </strong>{{ client.telephone || "-" }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Móvil: </strong>{{ client.mobile }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p
                v-if="!$store.state.roles.Backoffice_member_empresas"
                class="m-0 mr-2"
              >
                <strong>Fecha contrato: </strong
                >{{ $dateBackToFront(client.createdDate) }}
              </p>
              <p
                v-if="$store.state.roles.Backoffice_member_empresas"
                class="m-0 mr-2"
              >
                <strong>Fecha: </strong
                >{{ $dateBackToFront(client.createdDate) }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>Localidad: </strong
                >{{
                  client.deliveryAddress ? client.deliveryAddress.city : "-"
                }}
              </p>
            </div>
            <div
              class="d-flex align-items-center justify-content-start flex-wrap mb-2"
            >
              <p class="m-0 mr-2">
                <strong>CP: </strong
                >{{
                  client.deliveryAddress
                    ? client.deliveryAddress.postalCode
                    : "-"
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <ClientDetail
      :id="'clientDetail'"
      :modalTitle="'INFORMACIÓN DEL CLIENTE'"
      :class="'modal-xl'"
      :clientInfo="clientInfo"
      :whiteListInfo="whiteListInfo"
    >
    </ClientDetail>
    <ContractsList
      :id="'contractsDetail'"
      :modalTitle="'CONTRATOS DEL CLIENTE'"
      :class="'modal-xl'"
      :clientDni="clientDni"
    ></ContractsList>
    <ClientEdit
      :id="'clientEdit'"
      :modalTitle="'EDITAR DATOS DEL CLIENTE'"
      :class="'modal-xl'"
      :clientDni="clientDni"
      :indexClient="indexClient"
      @refreshParentList="refreshParentList"
    ></ClientEdit>
    <ModalError
      :id="'modalError'"
      :modalTitle="'SE HA PRODUCIDO UN ERROR'"
      :class="'modal'"
      :showFooter="false"
      :message="errorMessage"
      :code="errorCode"
    />
  </div>
</template>

<script>
import ClientDetail from "./ClientDetail.vue";
import ClientEdit from "./ClientEdit.vue";
import ContractsList from "./ContractsList.vue";
import ThOrder from "../../../Shared/ThOrder.vue";
import { Modal as ModalBootstrap } from "bootstrap";
import axios from "axios";
import ModalError from "../../../Shared/ModalError.vue";

export default {
  name: "ClientsList",
  props: ["clients"],
  data() {
    return {
      currentOrder: "",
      currentOrderBy: "",
      clientDni: "",
      clientInfo: "",
      indexClient: "",
      clientsAux: this.clients,
      errorMessage: "",
      errorCode: "",
      whiteListInfo: "",
    };
  },
  updated() {
    this.clientsAux = this.clients;
  },
  components: {
    ClientDetail,
    ClientEdit,
    ContractsList,
    ThOrder,
    ModalError,
  },

  computed: {
    canManageWhiteList() {
      // Verificar si el usuario tiene permisos para gestionar White List
      return (
        this.$store.state.roles.Backoffice_member ||
        this.$store.state.roles.Backoffice_supervisor
      );
    },
  },
  methods: {
    selectOrder(value) {
      this.clientsAux = this.clientsAux.sort(function (a, b) {
        let valorA =
          a[value.orderBy] == null || a[value.orderBy] == undefined
            ? 0
            : a[value.orderBy];
        let valorB =
          b[value.orderBy] == null || b[value.orderBy] == undefined
            ? 0
            : b[value.orderBy];
        if (valorA < valorB) return -1;
        if (valorA > valorB) return 1;
      });
      if (value.order == "DESC") this.clientsAux = this.clientsAux.reverse();
    },
    detalleClient: function (dni) {
      let urlClientes = "/customer/";
      let query = "?include=seniority";
      if (this.$store.state.roles.Backoffice_member_empresas) {
        urlClientes = "/business" + urlClientes + "get/";
        query = "";
      }

      axios
        .get(urlClientes + dni + query)
        .then((response) => {
          this.clientInfo = response.data;
          const myModal = new ModalBootstrap(
            document.getElementById("clientDetail")
          );
          myModal.show();

          return axios.get(`/customer/whitelist/${dni}`);
        })
        .then((response) => {
          this.whiteListInfo = response.data.whitelist;
          console.log(response.data.whitelist);
        })
        .catch((error) => {
          this.errorCode = error.response.data.code;
          this.errorMessage = error.response.data.message;
          const errorModal = new ModalBootstrap(
            document.getElementById("modalError")
          );
          errorModal.show();
        });
    },
    editarDetalle: function (index, dni, identifier) {
      this.clientDni = dni;
      this.indexClient = index;
      var myModal = new ModalBootstrap(document.getElementById(identifier));
      myModal.show();
    },
    refreshParentList(updatedClient) {
      // Buscar el cliente por legalIdentifier (DNI/CIF) ya que es más confiable
      const clientIndex = this.clientsAux.findIndex(
        (c) => c.legalIdentifier === updatedClient.legalIdentifier
      );

      if (clientIndex !== -1) {
        // Actualizar el cliente manteniendo la estructura necesaria para la lista
        this.clientsAux[clientIndex] = {
          ...this.clientsAux[clientIndex],
          ...updatedClient,
          // Asegurar que los campos específicos de la lista se mantengan actualizados
          email: updatedClient.email || this.clientsAux[clientIndex].email,
          mobile: updatedClient.mobile || this.clientsAux[clientIndex].mobile,
          telephone:
            updatedClient.telephone || this.clientsAux[clientIndex].telephone,
          deliveryAddress:
            updatedClient.deliveryAddress ||
            this.clientsAux[clientIndex].deliveryAddress,
          billingAddress:
            updatedClient.billingAddress ||
            this.clientsAux[clientIndex].billingAddress,
          trustworthy: updatedClient.trustworthy,
          categoryRating: updatedClient.categoryRating,
        };

        // Forzar reactividad si es necesario
        this.$forceUpdate();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#operaciones {
  text-align: right;
}

thead {
  background-color: rgb(250, 250, 250);
}

.col-12 {
  padding: 0%;
}

.menu-ellipsis {
  transform: translate3d(-115px, -95px, 0px) !important;
}
</style>
